export default "__VITE_ASSET__CjAzW3GL__"